import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=2006d366&scoped=true&"
import script from "./ContactUs.vue?vue&type=script&lang=js&"
export * from "./ContactUs.vue?vue&type=script&lang=js&"
import style0 from "./ContactUs.vue?vue&type=style&index=0&id=2006d366&prod&lang=scss&scoped=true&"
import style1 from "./ContactUs.vue?vue&type=style&index=1&id=2006d366&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006d366",
  null
  
)

export default component.exports